import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Users, Search, ChevronRight, AlertCircle } from "lucide-react";

export default function ProPatients() {
  const nav = useNavigate();
  const [patients, setPatients] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/patients").then((r) => setPatients(r.data)); }, []);
  const filtered = patients.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="max-w-4xl mx-auto space-y-5 animate-fade-up">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F3B4D] flex items-center gap-2"><Users className="text-[#0F766E]" /> Pacientes</h1>
        <p className="text-sm text-[#94A3B8]">Acompanhe cada pessoa e o que precisa de atenção.</p>
      </div>

      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#94A3B8]" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} data-testid="patient-search-input"
          placeholder="Buscar paciente…" className="pl-9 rounded-full border-[#E0F2FE] h-11" />
      </div>

      <div className="space-y-3">
        {filtered.map((p) => (
          <Card key={p.id} data-testid={`patient-row-${p.id}`} onClick={() => nav(`/pacientes/${p.id}`)}
            className="rounded-2xl p-4 border-[#E0F2FE] card-hover cursor-pointer flex items-center gap-4">
            <div className="w-11 h-11 rounded-full bg-[#0F766E] text-white grid place-items-center font-semibold">{p.name[0]}</div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-[#1F3B4D]">{p.name}</div>
              <div className="text-xs text-[#94A3B8]">{p.email}</div>
            </div>
            <div className="flex items-center gap-2">
              {p.pending_activities > 0 && <Badge className="bg-[#60A5FA]/15 text-[#2563eb] border-0">{p.pending_activities} p/ revisar</Badge>}
              {!p.has_next_action && <Badge className="bg-[#F59E0B]/15 text-[#b26a00] border-0 gap-1"><AlertCircle size={11} /> sem próxima ação</Badge>}
              <ChevronRight className="text-[#94A3B8]" />
            </div>
          </Card>
        ))}
        {filtered.length === 0 && <p className="text-sm text-[#94A3B8]">Nenhum paciente encontrado.</p>}
      </div>
    </div>
  );
}
